import { getLocale } from "../runtime";

const sv_mostpopular = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Mest populärt`
};

const mostpopular = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_mostpopular(inputs)
	return "mostPopular";
};

export { mostpopular as "mostPopular" };